import {RouteConfig} from 'vue-router'
import Layout from '@/layout/index.vue'

const equipRouter = {
  path: '/register',
  redirect: 'noredirect',
  name: 'register',
  component: Layout,
  children: [
    {
      path: 'register',
      component: () => import('@/views/register/index.vue'),
      name: 'register',
      meta: {
        title: '注册页面',
        icon: 'tissue',
        requireAuth: true,
      }
    },
  ]
}

export default equipRouter
